var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 24.25L18.8213 18.8213M18.8213 18.8213C19.7499 17.8927 20.4865 16.7902 20.989 15.5769C21.4916 14.3637 21.7503 13.0633 21.7503 11.75C21.7503 10.4368 21.4916 9.13637 20.989 7.92308C20.4865 6.70979 19.7499 5.60737 18.8213 4.67876C17.8927 3.75015 16.7902 3.01354 15.5769 2.51098C14.3637 2.00842 13.0633 1.74976 11.75 1.74976C10.4368 1.74976 9.13637 2.00842 7.92308 2.51098C6.70979 3.01354 5.60737 3.75015 4.67876 4.67876C2.80335 6.55418 1.74976 9.09778 1.74976 11.75C1.74976 14.4022 2.80335 16.9458 4.67876 18.8213C6.55417 20.6967 9.09778 21.7503 11.75 21.7503C14.4022 21.7503 16.9458 20.6967 18.8213 18.8213Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.0fb476cc8b4802c49cfa14c2a6fa0538.svg";
export { ForwardRef as ReactComponent };